define(
	'shared/crm',[
	"jquery",
	"underscore", 
	"shared/client"
	], function($, _, Client) {
	function CRM() {}
	
	// Static variables so multiple instances of object can't create multiple request
	CRM.subscription = null;
	CRM.progress = 0;
	CRM.isUpdateInProgress = false;
	CRM.num_buncees = null;
	

	CRM.prototype.fetchDataAndUpdate = function() {
		// Make this a no-op for now since the backend handles these variables anyways
		// May be modified/brought back later

		// var self = this;
		// if(window.appData.flags.userengage || window.appData.flags.intercom) {
		// 	if(!CRM.isUpdateInProgress) {
		// 		CRM.isUpdateInProgress = true;
		// 		if(window.appData.user) {
		// 			if(window.appData.user.data.school_guid) {
		// 				window.api.request('schools', window.appData.user.data.school_guid).execute().done(function(response) {
		// 					CRM.school_name = response.data.name;
		// 				}).always(function() {
		// 					CRM.progress = CRM.progress + 1;		
		// 					if(CRM.progress >= 2) {
		// 						self.update();
		// 					}
		// 				});
		// 			} else {
		// 				CRM.progress = CRM.progress + 1;	
		// 			}
		// 			if(window.appData.user.data.type !== "student" && Client.isPublic()) {
		// 				window.api.request('subscriptions').execute().done(function(response) {
		// 					CRM.subscription = response.data.plan.id;
		// 					if(response.data.status == "trialing") {
		// 						CRM.subscription = response.data.plan.id.replace(/monthly|yearly/gi, 'trial');
		// 					}
		// 				}).always(function() {
		// 					CRM.progress = CRM.progress + 1;		
		// 					if(CRM.progress >= 2) {
		// 						self.update();
		// 					}
		// 				});
		// 			} else {
		// 				CRM.progress = CRM.progress + 1;
		// 			}
		// 		}
		// 	}
		// }
	}

	CRM.prototype.setSubscription = function(subscription) {
		if(window.appData.flags.userengage) {
			CRM.subscription = subscription.plan.id;
			if(subscription.status == "trialing") {
				CRM.subscription = subscription.plan.id.replace(/monthly|yearly/gi, 'trial');
			}
			this.update();
		}
	}

	CRM.prototype.updateBunceesCount = function(count) {
		CRM.num_buncees = count;
		this.sendBunceeCountToCRM();
	}

	CRM.prototype.sendBunceeCountToCRM = _.debounce(function() {
		if(window.appData.flags.intercom) {
			var dataToSend = window.intercomData;
			dataToSend.numBuncees = CRM.num_buncees || 0;
			window.Intercom('update', dataToSend);
		}
	}, 5000);

	CRM.prototype.update = function() {
		if(window.appData.flags.userengage && window.UE) {
			var dataToSend = window.civchat;
			if(CRM.school_name) {
				dataToSend.school_name = CRM.school_name;
			}

			if(CRM.subscription) {
				dataToSend.subscription = CRM.subscription;
			}


			// debugger;
			UE.refresh(dataToSend);
			CRM.progress = 0;
			CRM.isUpdateInProgress = false;
		} else if(window.appData.flags.intercom && window.Intercom) {
			var dataToSend = window.intercomData;
			if(CRM.school_name) {
				dataToSend.school_name = CRM.school_name;
			}

			if(CRM.subscription) {
				dataToSend.subscription = CRM.subscription;
			}

			dataToSend.numBuncees = CRM.num_buncees || 0;

			window.Intercom('update', dataToSend);
			CRM.progress = 0;
			CRM.isUpdateInProgress = false;
		}
	}

	CRM.prototype.event = function(name, args) {
		if(args) {
			window.trackEvent(name, args);
		} else {
			window.trackEvent(name, null);
		}
	}

	return new CRM();
});
